import { Controller } from "@hotwired/stimulus"

// AI Companion — Agent Picker controller (Increment 4 Chat mode)
//
// When the user clicks an agent chip, fires a window-level custom event
// `companion:pick-agent` with `{agentId}` so the `ai--companion` controller
// can start a new chat bound to that agent. An empty agentId means "default
// companion" (no agent).
//
// Usage (rendered by AI::Companion::AgentPickerComponent):
//   <div data-controller="ai--companion--agent-picker">
//     <button data-action="click->ai--companion--agent-picker#pickAgent"
//             data-ai--companion--agent-picker-agent-id-param="<uuid>">
//       Deal Analyst
//     </button>
//   </div>
export default class extends Controller {
  pickAgent(event) {
    const agentId = event.params?.agentId ?? ""
    window.dispatchEvent(
      new CustomEvent("companion:pick-agent", {
        bubbles: true,
        detail: { agentId: agentId || null },
      }),
    )
  }
}
